exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i);", ""]);

// module
exports.push([module.id, ".popup {\n  width: 100%; }\n  .popup__icon {\n    width: 100%;\n    text-align: center;\n    margin-bottom: 20px; }\n    .popup__icon:before {\n      display: block;\n      font-size: 80px;\n      color: #ffc000; }\n      .popup__success .popup__icon:before {\n        color: #37ced0; }\n  .popup__title {\n    text-align: center;\n    margin-bottom: 10px; }\n    .popup__success .popup__title {\n      font-family: \"Quicksand\", sans-serif;\n      font-size: 28px; }\n  .popup__body {\n    font-size: 16px;\n    text-align: center;\n    line-height: 1.6; }\n  .popup__buttons {\n    display: flex;\n    justify-content: inherit;\n    align-items: inherit;\n    margin-top: 20px; }\n    .popup__buttons .button {\n      width: 100%; }\n      .popup__buttons .button + .button {\n        margin-left: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/Popup/Popup.scss
// module id = 659
// module chunks = 0